import { render, staticRenderFns } from "./BinMovementIcon.vue?vue&type=template&id=18f7d2f5&"
import script from "./BinMovementIcon.vue?vue&type=script&lang=js&"
export * from "./BinMovementIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports